import React from "react";
import { motion } from "framer-motion";
import { testimonials } from "../mock";

const marqueeItems = [
  "Websites", "Mobile Apps", "CRM", "SaaS Products", "AI", "WebGL", "Cloud", "UX/UI",
];

export default function Testimonials() {
  return (
    <section className="relative border-t border-white/5 py-20">
      {/* Marquee */}
      <div className="overflow-hidden py-6">
        <div className="flex w-max animate-marquee">
          {[...marqueeItems, ...marqueeItems].map((t, i) => (
            <span key={i} className="font-display mx-8 text-3xl font-bold uppercase text-white/15 md:text-5xl">
              {t} <span className="text-[#d4ff4e]">/</span>
            </span>
          ))}
        </div>
      </div>

      <div className="mx-auto mt-16 grid max-w-[1600px] gap-8 px-6 md:grid-cols-2 md:px-12">
        {testimonials.map((t, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: i * 0.1 }}
            className="rounded-2xl border border-white/10 bg-[#101012] p-8"
          >
            <p className="text-xl leading-relaxed text-white md:text-2xl">“{t.quote}”</p>
            <div className="mt-6 flex items-center gap-3">
              <span className="h-2 w-2 rounded-full bg-[#d4ff4e]" />
              <span className="font-display text-sm font-medium text-white">{t.author}</span>
              <span className="text-sm text-[#8a8a86]">— {t.title}</span>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
